import { apiClient } from '@/shared/api';
import type { SegmentCorrectionRequestRecord } from '@aegislab/shared';

export type { SegmentCorrectionRequestRecord };

export interface ReviewedSegmentCorrectionsParams {
  from: string;
  to: string;
  status?: 'APPROVED' | 'REJECTED';
}

// 세그먼트(휴식/근무) 정정 조회 — 생성은 features/attendance-correction-request,
// 승인/반려는 features/attendance-correction-review 소관.

export const fetchMySegmentCorrections = async (): Promise<SegmentCorrectionRequestRecord[]> => {
  const response = await apiClient.get<SegmentCorrectionRequestRecord[]>(
    '/attendance/segment-correction'
  );
  return response.data;
};

export const fetchPendingSegmentCorrections = async (): Promise<
  SegmentCorrectionRequestRecord[]
> => {
  const response = await apiClient.get<SegmentCorrectionRequestRecord[]>(
    '/attendance/segment-correction/pending'
  );
  return response.data;
};

export const fetchReviewedSegmentCorrections = async (
  params: ReviewedSegmentCorrectionsParams
): Promise<SegmentCorrectionRequestRecord[]> => {
  const response = await apiClient.get<SegmentCorrectionRequestRecord[]>(
    '/attendance/segment-correction/reviewed',
    { params }
  );
  return response.data;
};
